import { vars } from "@common/styles";
import { Flex as BaseFlex } from "@common/styles/reusable/Flex/Flex.styles";
import { rgba } from "polished";
import styled, { css } from "styled-components";

export const SidebarWrap = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${vars.colors.grey100};
  width: 7.2rem;
  margin-bottom: 0.3rem;
  border-right: 1px solid ${vars.colors.grey90};

  opacity: 0.6;
  cursor: not-allowed !important;

  span {
    opacity: 0.6;

    &:hover {
      opacity: 0.6;
    }
  }

  ${(props) =>
    props.$active &&
    css`
      z-index: 100;
    `};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SidebarIconWrap = styled.div`
  position: relative;
`;

export const SidebarCanvasWrap = styled.div`
  > div {
    cursor: not-allowed !important;
  }

  padding: 2rem 1.2rem;
  display: flex;
  justify-content: center;
`;

export const SidebarLinks = styled.ul`
  flex: 1;
  margin-top: 1rem;
  padding: 0;
  list-style: none;
  z-index: 5;

  a {
    text-decoration: none;

    &::before {
      content: "";
      display: block;
      width: 0.4rem;
      height: 3.6rem;
      border-radius: 2px;
      margin: auto;
      position: absolute;
      top: 0;
      left: 0.1rem;
      bottom: 0;
      transition: ${vars.transitions.hover};
    }

    &:hover,
    &:focus-within,
    &:active {
      text-decoration: none;
      p {
        color: ${vars.colors.grey30};
        cursor: not-allowed !important;
      }
    }

    &.active {
      &::before {
        height: 1.7rem;
        background-color: ${vars.colors.purple};
      }

      p {
        text-decoration: none;
        color: ${vars.colors.grey30};
      }

      svg {
        path {
          stroke: ${vars.colors.grey30};
        }
      }
    }

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 7.2rem;

      position: relative;

      svg {
        transition: ${vars.transitions.hover};

        path {
          stroke: ${vars.colors.grey60};
        }
      }

      .__react_component_tooltip {
        box-shadow: none;
        margin-right: -3rem;
      }
    }
  }
`;

export const SidebarTop = styled.div``;

export const SidebarBottom = styled.div`
  margin-top: 4rem;

  > * {
    &:not(:first-child) {
      margin-top: 2rem;
    }
  }
`;

export const Flex = styled(BaseFlex)`
  color: ${vars.colors.grey30};
  &:hover {
    color: ${vars.colors.white};
  }
`;

export const ModalOverlay = styled.div<{ $active?: boolean }>`
  background-color: ${rgba("#000", 0)};
  position: fixed;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: ${vars.transitions.hover};
  opacity: 0;
  pointer-events: none;
  z-index: -1;

  /* active */
  ${(props) =>
    props.$active &&
    css`
      opacity: 1;
      pointer-events: auto;
      z-index: ${vars.zIndex.modalOverlay};
    `}
`;

export const NotificationIndicator = styled.div`
  border-radius: 50%;
  background-color: ${vars.colors.red};

  width: 2.2rem;
  height: 2.2rem;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CluesDiv = styled.div`
  padding-top: 0.1rem;
`;
